export type SubItem = {
  name: string
  url: string
  iconName?: string
  subModuleId?: number
}

export type MenuItem = {
  name: string
  url?: string
  iconName?: string
  subItems?: SubItem[] | undefined
  subModuleId?: number
}

export const menuItems: MenuItem[] = [
  {
    name: 'eCMR Projecten',
    url: '/home/project/active-ecmr-projects',
    subModuleId: 22,
  },
  {
    name: 'eCMR Formulieren',
    url: '/home/project/ecmr-formulieren',
    subModuleId: 21,
  },
  {
    name: 'Projecten',
    url: '/home/project/active-projects-deellocatie',
    subModuleId: 24,
  },
  {
    name: 'Formulieren',
    url: '/home/project/formulieren',
    subModuleId: 3,
  },
  {
    name: 'Projecten Lite',
    url: '/home/project/active-projects-lite',
    subModuleId: 36,
  },
  {
    name: 'Projecten (no idf)',
    url: '/home/project/active-projects-no-product-idf',
    subModuleId: 38,
  },
  {
    name: 'Grondbank Projecten',
    url: '/home/project/active-projects-no-product-idf-grondbank',
    subModuleId: 43,
  },
  {
    name: 'Grondbank Projecten (no carrier)',
    url: '/home/project/active-projects-no-vervoerder-idf-grondbank',
    subModuleId: 44,
  },
  {
    name: 'Projecten (ship)',
    url: '/home/project/active-projects-schip',
    subModuleId: 35,
  },
  {
    name: 'Projecten (new)',
    url: '/home/project/active-projects-vue',
    subModuleId: 100,
  },
  {
    name: 'eCMR Ritten',
    url: '/home/project/ecmr-rapportage',
    subModuleId: 25,
  },
  {
    name: 'Ritten',
    url: '/home/project/rapportage',
    subModuleId: 14,
  },
  {
    name: 'Ritten (relatie)',
    url: '/home/project/rapportage-relation',
    subModuleId: 39,
  },
  {
    name: 'Ritten (no carrier)',
    url: '/home/project/rapportage-no-carrier',
    subModuleId: 45,
  },
  {
    name: 'Ritten & Vaarten',
    url: '/home/project/ship-reports',
    subModuleId: 46,
  },
  {
    name: 'Ritten v2',
    url: '/home/project/rapportage-v2',
    subModuleId: 56,
  },
  {
    name: 'Ritten intern',
    url: '/home/project/rapportage-intern',
    subModuleId: 51,
  },
  {
    name: 'Handhaving',
    iconName: 'listIcon',
    subItems: [
      {
        name: 'Vertrokken vrachten',
        url: '/home/handhaving/departed-journeys',
        subModuleId: 7,
      },
      {
        name: 'Finale vrachten',
        url: '/home/handhaving/final-journeys',
        subModuleId: 8,
      },
    ],
  },
  {
    name: 'Beheer',
    iconName: 'listIcon',
    subItems: [
      {
        name: 'Accounts',
        url: '/home/control/accounts',
        subModuleId: 15,
      },
      {
        name: 'New Client',
        url: '/home/control/new-client',
        subModuleId: 16,
      },
      {
        name: 'Producten (ECMR)',
        url: '/home/control/ecmr-products',
        subModuleId: 23,
      },
      {
        name: 'Producten',
        url: '/home/control/products',
        subModuleId: 6,
      },
      {
        name: 'Archive',
        url: '/home/control/archived-projects',
        subModuleId: 2, // TODO Check Aertssen archive
      },
      {
        name: 'Aanmeldingen',
        url: '/home/control/app-registrations',
        subModuleId: 108,
      },
      {
        name: 'Organisaties',
        url: '/home/control/organizations',
        subModuleId: 109,
      },
      {
        name: 'Relaties',
        url: '/home/control/relations',
        subModuleId: 37,
      },
      {
        name: 'Customer',
        url: '/home/control/customer',
        subModuleId: 104,
      },
    ],
  },
  {
    name: 'Extern',
    iconName: 'listIcon',
    subItems: [
      {
        name: 'Home',
        url: '/home/external/home',
        subModuleId: 54,
      },
      {
        name: 'Intern',
        url: '/home/external/internal',
        subModuleId: 55,
      },
    ],
  },
  {
    name: 'LZP',
    iconName: 'listIcon',
    subItems: [
      {
        name: 'Clients',
        url: '/home/lzp/clients',
        subModuleId: 17,
      },
      {
        name: 'Administration',
        url: '/home/lzp/administration',
        subModuleId: 52,
      },
      {
        name: 'IOP Berichten Overzicht',
        url: '/iop/berichten',
        subModuleId: 74,
      },
      {
        name: 'IOP processing failures',
        url: '/iop/failures',
        subModuleId: 78,
      },
      {
        name: 'Switcher',
        url: '/home/lzp/switcher',
        subModuleId: 101,
      },
    ],
  },
  {
    name: 'IOP management',
    iconName: 'listIcon',
    subItems: [
      {
        name: 'Beheer Iop Connectie',
        url: '/iop/beheer',
        subModuleId: 75,
      },
    ],
  },
]

export const routes = {
  // Beheer
  'account-view': '/auth/web/page/account-view',
  'ecmr-products': '/ecmr/web/page/ecmr-products',
  'archived-projects': '/idf/web/page/archived-projects',
  // 'archived-projects', // TODO - make this normal archived-projects:  '/idf/web/page/archived-projects-deellocatie', check if this is not 100% the same
  products: '/idf/web/page/products',
  'registered-apps': '/idf/web/page/registered-apps',
  organisaties: '/web/page/organisaties',
  relaties: '/web/page/relaties',

  // Extern
  'audit-home': '/idf/web/page/audit-home',
  'audit-intern': '/idf/web/page/audit-intern',

  // LZP
  'client-view': '/auth/web/page/client-view',
  'new-client': '/auth/web/page/new-client',
  administration: '/idf/web/page/administration/administration',
  'org-switcher': '/idf/web/page/org-switcher',

  other: {
    'setup-client': '/auth/web/page/setup-client',
    'administration-details': '/idf/web/page/administration/administration-details',
    'project-lite-create-idf': '/idf/web/page/project-lite-create-idf',
    'project-no-product-idf': '/idf/web/page/project-no-product-idf',
    'project-no-product-idf-grondbank': '/idf/web/page/project-no-product-idf-grondbank',
    'project-no-vervoerder-idf-grondbank': '/idf/web/page/project-no-vervoerder-idf-grondbank',
    'project-legacy': '/idf/web/page/project',
    project: '/idf/web/page/project-deellocatie',
    'project-lite': '/idf/web/page/project-lite',
    'schip-create-idf': '/idf/web/page/schip-create-idf', // TODO needs to be verified
    'schip-project': '/idf/web/page/schip-project',
    relatie: '/web/page/relatie',
    'project-ecmr': '/ecmr/web/page/project',
    projectv2: '/idf/web/page/projectv2',
  },
  // Not in nav
}
